export const GET_QUOTATION_DATA = 'GET_QUOTATION_DATA'
export const GET_QUOTATION_DATA_SUCCESS = 'GET_QUOTATION_DATA_SUCCESS'
export const GET_QUOTATION_DATA_FAIL = 'GET_QUOTATION_DATA_FAIL'
export const FILTER_QUOTATION_DATA = 'FILTER_QUOTATION_DATA'

export const UPDATE_SEARCH_QUOTATION_DATA = 'UPDATE_SEARCH_QUOTATION_DATA'
export const UPDATE_SEARCH_QUOTATION_SWAP = 'UPDATE_SEARCH_QUOTATION_SWAP'
export const UPDATE_SEARCH_QUOTATION_DATE = 'UPDATE_SEARCH_QUOTATION_DATE'
export const UPDATE_CONTAINERTYPE_CONFIRM = 'UPDATE_CONTAINERTYPE_CONFIRM'
export const UPDATE_CONTAINER_CHANGE = 'UPDATE_CONTAINER_CHANGE'
export const UPDATE_VALUE_BLANK = 'UPDATE_VALUE_BLANK'
export const SEARCH_QUOTATION_BLANK = 'SEARCH_QUOTATION_BLANK'

// export const GET_QUOTATION_RESULT_DATA = 'GET_QUOTATION_RESULT_DATA'
// export const GET_QUOTATION_RESULT_DATA1 = 'GET_QUOTATION_RESULT_DATA1'
// export const GET_QUOTATION_RESULT_DATA2 = 'GET_QUOTATION_RESULT_DATA2'
// export const GET_QUOTATION_RESULT_DATA3 = 'GET_QUOTATION_RESULT_DATA3'
// export const GET_QUOTATION_RESULT_SUCCESS = 'GET_QUOTATION_RESULT_SUCCESS'
// export const GET_QUOTATION_RESULT_FAIL = 'GET_QUOTATION_RESULT_FAIL'

// export const UPDATE_QUOTATION_RESULT_DETAILS = 'UPDATE_QUOTATION_RESULT_DETAILS'
// export const QUOTATION_RESULT_SELECTED = 'QUOTATION_RESULT_SELECTED'
// export const QUOTATION_RESULT_SELECTED_BLANK = 'QUOTATION_RESULT_SELECTED_BLANK'
// export const QUOTATION_RESULT_UPDATE = 'QUOTATION_RESULT_UPDATE'
// export const CONFIRM_PREVIEW_DATA = 'CONFIRM_PREVIEW_DATA'

export const GET_INQUIRY_DATA = 'GET_INQUIRY_DATA';
export const GET_INQUIRY_DATA_SUCCESS = 'GET_INQUIRY_DATA_SUCCESS';
export const GET_INQUIRY_DATA_LOADER="GET_INQUIRY_DATA_LOADER";
export const GET_INQUIRY_DATA_FAIL = 'GET_INQUIRY_DATA_FAIL';
export const FILTER_INQUIRY_DATA = 'FILTER_INQUIRY_DATA';

export const GET_INQUIRY_CUSTOMER_SUMMARY_DATA='GET_INQUIRY_CUSTOMER_SUMMARY'
export const GET_INQUIRY_CUSTOMER_SUMMARY_DATA_SUCCESS='GET_INQUIRY_CUSTOMER_SUMMARY_DATA_SUCCESS'

export const GET_INQUIRY_SALES_CUSTOMER_SUMMARY_DATA='GET_INQUIRY_SALES_CUSTOMER_SUMMARY_DATA'
export const GET_INQUIRY_SALES_CUSTOMER_SUMMARY_DATA_SUCCESS='GET_INQUIRY_SALES_CUSTOMER_SUMMARY_DATA_SUCCESS'

export const GET_INQUIRY_EXPORT_SUMMARY_DATA='GET_INQUIRY_EXPORT_SUMMARY_DATA'
export const GET_INQUIRY_EXPORT_SUMMARY_DATA_SUCCESS='GET_INQUIRY_EXPORT_SUMMARY_DATA_SUCCESS'

export const GET_INQUIRY_IMPORT_SUMMARY_DATA='GET_INQUIRY_IMPORT_SUMMARY_DATA'
export const GET_INQUIRY_IMPORT_SUMMARY__DATA_SUCCESS='GET_INQUIRY_IMPORT_SUMMARY__DATA_SUCCESS'

export const GET_INQUIRY_SUMMARY_DATA='GET_INQUIRY_SUMMARY_DATA'
export const GET_INQUIRY_SUMMARY_DATA_SUCCESS='GET_INQUIRY_SUMMARY_DATA_SUCCESS'


export const GET_DASHBOARD_INQUIRY_SUMMARY_DATA='GET_DASHBOARD_INQUIRY_SUMMARY_DATA'
export const GET_DASHBOARD_INQUIRY_SUMMARY_DATA_SUCCESS='GET_DASHBOARD_INQUIRY_SUMMARY_DATA_SUCCESS'

export const GET_SHIPPER_DASHBOARD_INQUIRY_SUMMARY_DATA='GET_SHIPPER_DASHBOARD_INQUIRY_SUMMARY_DATA'


export const GET_QUOTATION_HISTORY_DATA_BY_ID='GET_QUOTATION_HISTORY_DATA_BY_ID'
export const GET_QUOTATION_HISTORY_DATA_SUCCESS='GET_QUOTATION_HISTORY_DATA_SUCCESS'

export const GET_ALL_QUOTATION_COMPARISON_DATA='GET_ALL_QUOTATION_COMPARISON_DATA';
export const GET_ALL_QUOTATION_COMPARISON_DATA_SUCCESS='GET_ALL_QUOTATION_COMPARISON_DATA_SUCCESS';


export const GET_QUOTATION_SELLER_DETAILS_LIST_BY_ID = "GET_QUOTATION_SELLER_DETAILS_LIST_BY_ID";
export const GET_QUOTATION_SELLER_DETAILS_LIST_SUCCESS = "GET_QUOTATION_SELLER_DETAILS_LIST_SUCCESS";

export const GET_NETWORK_INQUIRIES_SUMMARY = "GET_NETWORK_INQUIRIES_SUMMARY";
export const GET_NETWORK_INQUIRIES_SUMMARY_SUCCESS = "GET_NETWORK_INQUIRIES_SUMMARY_SUCCESS";

export const GET_NETWORK_INQUIRIES_BIDS_SUMMARY = "GET_NETWORK_INQUIRIES_BIDS_SUMMARY";
export const GET_NETWORK_INQUIRIES_BIDS_SUMMARY_SUCCESS = "GET_NETWORK_INQUIRIES_BIDS_SUMMARY_SUCCESS";

export const GET_NETWORK_ACTIVE_INQUIRIES_DETAILS = "GET_NETWORK_ACTIVE_INQUIRIES_DETAILS";
export const GET_NETWORK_ACTIVE_INQUIRIES_DETAILS_SUCCESS = "GET_NETWORK_ACTIVE_INQUIRIES_DETAILS_SUCCESS";


export const GET_NETWORK_FREIGHT_LEADS_STATS = "GET_NETWORK_FREIGHT_LEADS_STATS";
export const GET_NETWORK_FREIGHT_LEADS_STATS_SUCCESS = "GET_NETWORK_FREIGHT_LEADS_STATS_SUCCESS";

export const BOOKINGS_STATUS_INIT = "BOOKINGS_STATUS_INIT";
export const BOOKINGS_STATUS_LOADER = "BOOKINGS_STATUS_LOADER";
export const BOOKINGS_STATUS_REQUEST = "BOOKINGS_STATUS_REQUEST";
export const BOOKINGS_STATUS_REQUEST_SUCCESS = "BOOKINGS_STATUS_REQUEST_SUCCESS";
export const BOOKINGS_STATUS_REQUEST_FAIL = "BOOKINGS_STATUS_REQUEST_FAIL";

